export const EMOJI = '🚀 👍 👨🏻‍💻';

export const FONTS = `
<style>
.f1 {
font-family: 'Pacifico';
}
.f2 {
font-family: 'Inter';
}
.f3:after {
font-family: "Font Awesome 5 Brands"; content: "\\f099";
}
</style>

<h1 class="f1">Hello 🚀</h1>
<h1 class="f2">Hello 👨🏻‍💻</h1>
<h1 class="f3">Hello</h1>
`;
